import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'

type UploadPath = 'generation_load' | 'rpgi' | 'system_load'

export type UploadResponse = Readonly<{
  message: string
}>

@Injectable({ providedIn: 'root' })
export class ExpectedResultsService {
  private readonly http = inject(HttpClient)

  upload(path: UploadPath, file: File): Observable<UploadResponse> {
    const formData = new FormData()
    formData.append('newfile', file)
    return this.http.post<UploadResponse>(`expected_results/${path}`, formData)
  }

  generationLoad(file: File): Observable<UploadResponse> {
    return this.upload('generation_load', file)
  }

  rpgiLoad(file: File): Observable<UploadResponse> {
    return this.upload('rpgi', file)
  }

  systemLoad(file: File): Observable<UploadResponse> {
    return this.upload('system_load', file)
  }
}